var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[(_vm.loadData)?_c('DatatableV2',{attrs:{"displayTitle":false,"flat":true,"url":_vm.apiUrl}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }